// Terminal input component
import React, { forwardRef, useState } from 'react';

const TerminalInput = forwardRef(({ value, onChange, onSubmit, onKeyDown, busy }, ref) => {
  const [focused, setFocused] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit(value);
      return;
    }
    if (onKeyDown) onKeyDown(e);
  };

  // While a command runs the prompt is hidden, but the field stays
  // mounted and focusable so focus, selection and paste survive.
  return (
    <div className="terminal-input" hidden={busy}>
      <span className="prompt-user">attuul@portfolio</span>
      <span className="prompt-path">~</span>
      <span className="prompt-caret">❯</span>
      {/* Text and cursor share one flex item so the row's gap can't
          open a space between them — a terminal cursor sits flush. */}
      <span className="input-line">
        <span className="input-echo">{value}</span>
        <span className={`cursor${focused ? '' : ' cursor-idle'}`} />
      </span>
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className="input-hidden"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        aria-label="Terminal input"
      />
    </div>
  );
});

TerminalInput.displayName = 'TerminalInput';

export default TerminalInput;
